import { Outlet } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { AssetsProvider } from './AssetsProvider'
import {
  ErrorFallback,
  Footer,
  Header,
  HeaderCap,
  SkipToMainContent,
  Status
} from '../../components'
import { ErrorBoundary } from 'react-error-boundary'
import { Tour } from './Tour'
import { useLayoutViewModel } from './useLayoutViewModel'
import styled from 'styled-components'

const AppContainer = styled(Container)`
  @media (min-width: 992px) {
    padding-top: 90px;
  }
`

const Layout = () => {
  const {
    disabled,
    options,
    selectedOption,
    handleOptionSelect,
    links,
    loggedIn,
    handleLogin,
    user,
    userOptions,
    handleUserOptionSelect,
    helpOptions,
    handleHelpOptionSelect,
    category,
    isGlobal,
    steps,
    runTour,
    onTourClose
  } = useLayoutViewModel()

  return (
    <AssetsProvider>
      <AppContainer className='app-container' fluid>
        <SkipToMainContent />
        <HeaderCap className='header-cap' />
        <Header
          className='header'
          expand='lg'
          collapseOnSelect
          bg='white'
          variant='light'
          disabled={disabled}
          options={options}
          selectedOption={selectedOption}
          onOptionSelect={handleOptionSelect}
          links={links}
          loggedIn={loggedIn}
          onLogin={handleLogin}
          userName={user?.fullName}
          userOptions={userOptions}
          onUserOptionSelect={handleUserOptionSelect}
          helpOptions={helpOptions}
          onHelpOptionSelect={handleHelpOptionSelect}
        />
        <Container fluid>
          <Status />
          <main id='main-content'>
            <ErrorBoundary fallback={<ErrorFallback />}>
              <Outlet />
            </ErrorBoundary>
          </main>
          <Footer />
        </Container>
        {category && steps ? (
          <Tour
            category={category}
            global={isGlobal}
            steps={steps}
            runTour={runTour}
            onClose={onTourClose}
          />
        ) : null}
      </AppContainer>
    </AssetsProvider>
  )
}

export { Layout }
